export default {
    title: `Editorial`,
    titleUK: `Editorial`,

    subTitleMC: `Nicolas Feit, Head of Societe Generale Private Banking Monaco`,
    subTitleFR: `Mathieu Vedrenne, Head of Societe Generale Private Banking France`,
    subTitleLU: `Olivier Lecler, Head of Societe Generale Private Banking Luxembourg`,
    subTitleCH: `Franck Bonin, Head of Societe Generale Private Banking Switzerland`,
    subTitleUK: `Mouhammed Choukeir, CEO of SG Kleinwort Hambros`,

    mainContent: `
    <p>
    <strong>Heïdi Sevestre, renowned and committed glaciologist, is the featured guest of this issue.</strong> She takes us on an up close analysis of the state of the world’s glaciers and the challenges they face in a heating world. Next, a scientist and a water management expert will share the strategies adopted by island or coastal countries, and in particular the Netherlands, in order to cope with accelerating sea level rise.
    </p>
    <p>
    Water, a true common thread of this issue, will also carry us to Venice, mythical city of the Doges that still has a few hidden secrets to be discovered. You will also be invited to board the museum ship inaugurated this year by the Art Explora foundation. It will sail across the Mediterranean for two years, meeting culture-lovers from around fifteen countries.
    </p>
    <p>
    We do hope you enjoy reading this issue of PB magazine!
    </p>`,

    mainContentUK: `
    <p>
    <strong>Heïdi Sevestre, renowned and committed glaciologist, is the featured guest of this issue.</strong> She takes us on an up close analysis of the state of the world’s glaciers and the challenges they face in a heating world. Next, a scientist and a water management expert will share the strategies adopted by island or coastal countries, and in particular the Netherlands, in order to cope with accelerating sea level rise.
    </p>
    <p>
    Water, a true common thread of this issue, will also carry us to Venice, mythical city of the Doges that still has a few hidden secrets to be discovered. You will also be invited to board the museum ship inaugurated this year by the Art Explora foundation. It will sail across the Mediterranean for two years, meeting culture-lovers from around fifteen countries.
    </p>
    <p>
    We do hope you enjoy reading this issue of PB magazine!
    </p>`,
};